import React from 'react';
import Icon from './Icon';

const ExternalLinkIcon = (props) => (
    <Icon {...props}>
        <path
            d="M12 4H6A2 2 0 0 0 4 6V18A2 2 0 0 0 6 20H18A2 2 0 0 0 20 18V12M15 4H20V9M20 4L10 14"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </Icon>
);

export default ExternalLinkIcon;